import React from "react"
import { createIcon } from "@chakra-ui/icons"

const WarningIcon = createIcon({
  displayName: "TwitterIcon",
  viewBox: "0 0 12 13",
  path: (
    <svg
      fill="none"
      height="13"
      viewBox="0 0 12 13"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8125 6.5C11.8125 3.3125 9.1875 0.6875 6 0.6875C2.78906 0.6875 0.1875 3.3125 0.1875 6.5C0.1875 9.71094 2.78906 12.3125 6 12.3125C9.1875 12.3125 11.8125 9.71094 11.8125 6.5ZM6 7.67188C6.58594 7.67188 7.07812 8.16406 7.07812 8.75C7.07812 9.35938 6.58594 9.82812 6 9.82812C5.39062 9.82812 4.92188 9.35938 4.92188 8.75C4.92188 8.16406 5.39062 7.67188 6 7.67188ZM4.96875 3.80469C4.94531 3.64062 5.08594 3.5 5.25 3.5H6.72656C6.89062 3.5 7.03125 3.64062 7.00781 3.80469L6.84375 6.99219C6.82031 7.15625 6.70312 7.25 6.5625 7.25H5.41406C5.27344 7.25 5.15625 7.15625 5.13281 6.99219L4.96875 3.80469Z"
        fill="#FFBF00"
      />
    </svg>
  ),
})

export default WarningIcon
